<template>
  <div>
    <Modal v-model="show" :title="type == 'add' ?$t('add'):$t('edit')" :mask-closable="false" width="800" @on-cancel="cancel">
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="120" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-cn_cname" :label="$t('renewal.name')">
                  <Input type="text" v-model="form['zh-cn_cname']" placeholder="请输入续费套餐名称"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-tw_cname" :label="$t('renewal.name')">
                  <Input type="text" v-model="form['zh-tw_cname']" placeholder="請輸入續費套餐名稱"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="tabs_item">
                <FormItem class="item_input" prop="en_cname" :label="$t('renewal.name')">
                  <Input type="text" v-model="form.en_cname" placeholder="Please enter the renewal package name"></Input>
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
          <div class="item">
            <FormItem :label="$t('role')" prop="role_id">
              <Select v-model="form.role_id" :placeholder="tabs == 1 ? '请选择角色':tabs == 2 ? '請選擇角色':'Please select a role'" class="input">
                <Option v-for="(item,index) in roleList" :value="item.key" :key="index">{{ item.value }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="days" :label="$t('yfee_xd')">
              <InputNumber :min="1" v-model="form.days" :placeholder="tabs == 1 ? '请输入有效天数':tabs == 2 ? '請輸入有效天數':'Please enter valid days'"></InputNumber>
            </FormItem>
            <FormItem prop="price" :label="$t('price')">
              <InputNumber :min="1" v-model="form.price" :placeholder="tabs == 1 ? '请输入单价':tabs == 2 ? '請輸入單價':'Please enter unit price'"></InputNumber>
            </FormItem>
            <FormItem prop="sort_id" :label="$t('sort')">
              <InputNumber :min="1" v-model="form.sort_id" :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"></InputNumber>
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String,
    roleList: Array
  },
  data () {
    return {
      tabs: '1',
      switch1: false,
      form: {
        renewal_id: null,
        sort_id: null,
        en_cname: "",
        en_cdesc: "",
        en_image: "",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-cn_image": "",
        "zh-tw_cdesc": "",
        "zh-tw_cname": "",
        "zh-tw_image": "",
        role_id: null,
        days: null,
        price: null,
      },
      ruleInline: {
        'zh-cn_cname': [
          {
            required: true,
            message: this.$t("renewal.cname_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_cname': [
          {
            required: true,
            message: this.$t("renewal.cname_input"),
            trigger: "blur"
          }
        ],
        en_cname: [
          {
            required: true,
            message: this.$t("renewal.cname_input"),
            trigger: "blur"
          }
        ],
        days: [
          {
            type: 'number',
            required: true,
            message: this.$t("renewal.days_input"),
            trigger: "blur"
          }
        ],
        price: [
          {
            type: 'number',
            required: true,
            message: this.$t("renewal.price_input"),
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
        role_id: [
          {
            required: true,
            message: this.$t('select_role'),
            trigger: 'change'
          }
        ],
      },
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'renewal/before-upd',
          { renewal_id: this.itemObj.renewal_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.sort_id = this.form.sort_id * 1
            this.form.days = this.form.days * 1
            this.form.price = this.form.price * 1
          }
        );
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'renewal/add' : 'renewal/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/renewal/module/renewal_edit.vue